import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {AmbienteEnum} from '../../shared/enums/ambiente-enum';
import {SociedadEnum} from '../../shared/enums/sociedad-enum';
import {MENU_PERMISSIONS} from '../constants/menu-permissions.constant';

export const SEGURIDAD_MENU: AppMenuItem = {
  "children": [
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "label": "Dashboard",
      "proceso": MENU_PERMISSIONS.dashboardSeguridad,
      "route": "seguridad/dashboard",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Rol",
          "route": "seguridad/roles/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Rol",
          "route": "seguridad/roles/agregar",
          "visible": false
        }
      ],
      "label": "Roles",
      "proceso": MENU_PERMISSIONS.roles,
      "route": "seguridad/roles",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Grupo",
          "route": "seguridad/grupos/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Grupo",
          "route": "seguridad/grupos/agregar",
          "visible": false
        }
      ],
      "label": "Grupos",
      "proceso": MENU_PERMISSIONS.grupos,
      "route": "seguridad/grupos",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Permiso",
          "route": "seguridad/permisos/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Permiso",
          "route": "seguridad/permisos/agregar",
          "visible": false
        }
      ],
      "label": "Permisos",
      "proceso": MENU_PERMISSIONS.permisos,
      "route": "seguridad/permisos",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Agregar Rol Permiso",
          "route": "seguridad/roles-permisos/agregar",
          "visible": false
        }
      ],
      "label": "Roles Permisos",
      "proceso": MENU_PERMISSIONS.rolPermiso,
      "route": "seguridad/roles-permisos",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Asignar Roles a Usuario",
          "route": "seguridad/roles-usuarios/asignar",
          "visible": false
        }
      ],
      "label": "Roles Usuarios",
      "proceso": MENU_PERMISSIONS.rolesUsuarios,
      "route": "seguridad/roles-usuarios",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Tipo Acceso",
          "route": "seguridad/tipo-acceso/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Tipo Acceso",
          "route": "seguridad/tipo-acceso/agregar",
          "visible": false
        }
      ],
      "label": "Tipo Acceso",
      "proceso": MENU_PERMISSIONS.tipoAcceso,
      "route": "seguridad/tipo-acceso",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Asignar Tipo Acceso a Usuario",
          "route": "seguridad/tipo-acceso-usuarios/asignar",
          "visible": false
        }
      ],
      "label": "Tipo Acceso Usuarios",
      "proceso": MENU_PERMISSIONS.tipoAccesoUsuarios,
      "route": "seguridad/tipo-acceso-usuarios",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Sociedad",
          "route": "seguridad/sociedades/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Sociedad",
          "route": "seguridad/sociedades/agregar",
          "visible": false
        }
      ],
      "label": "Sociedades",
      "proceso": MENU_PERMISSIONS.sociedades,
      "route": "seguridad/sociedades",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": false
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Aplicación",
          "route": "seguridad/aplicaciones/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Aplicación",
          "route": "seguridad/aplicaciones/agregar",
          "visible": false
        }
      ],
      "label": "Aplicaciones",
      "proceso": MENU_PERMISSIONS.aplicaciones,
      "route": "seguridad/aplicaciones",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": false
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Roles Grupos",
          "route": "seguridad/roles-grupos/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Roles Grupos",
          "route": "seguridad/roles-grupos/agregar",
          "visible": false
        }
      ],
      "label": "Roles Grupos",
      "proceso": MENU_PERMISSIONS.rolesGrupos,
      "route": "seguridad/roles-grupos",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.SOPORT,
        SociedadEnum.MX
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Lista Usuarios",
          "route": "seguridad/usuarios-lista",
          "visible": true
        },
        {
          "breadcrumb": true,
          "label": "Editar Usuario",
          "route": "seguridad/usuarios/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Usuario",
          "route": "seguridad/usuarios/agregar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Huellas Digitales",
          "route": "seguridad/usuarios/captura-huellas",
          "visible": true
        },
        {
          "breadcrumb": true,
          "label": "Asignar Grupo a Usuario",
          "route": "seguridad/usuarios-grupos",
          "visible": true
        }
      ],
      "label": "Usuarios",
      "proceso": MENU_PERMISSIONS.usuarios,
      "route": "seguridad/usuarios-lista",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    }
  ],
  "label": "Seguridad",
  "visible": true
};
